import React from 'react'
import type { ReactNode } from 'react'
import { Typography, type TypographyVariant, type TypographySizes } from '../../../index'

type BaseTitleProps<V extends TypographyVariant> = {
  children: ReactNode
  variant?: V
  size?: TypographySizes<V>
}

type TitleProps = {
  [V in TypographyVariant]: BaseTitleProps<V>
}[TypographyVariant]

function Title(props: TitleProps) {
  const { children, variant = 'caption', size = 'l' } = props

  return (
    <Typography {...({ variant, size, bold: true, children } as Parameters<typeof Typography>[0])}>
      {children}
    </Typography>
  )
}

Title.displayName = 'MessageBox.Title'

export { Title }
